import Divider from './Divider'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'featured-product-list' }>

// TODO: refactor this to remove 'product necessity
function FeaturedProductList(block: BlockProps): ReactElement {
  const { products } = block

  return (
    <div>
      {products &&
        products.map(product => {
          return (
            <FeaturedProductList product={product} key={`featured-product-map--${product.id}`} />
          )
        })}
      <Divider withLine={true} />
    </div>
  )
}

export default FeaturedProductList
